/*
 * app-config
 */
import type { AppConfig } from "@emr/types"
import { getEnvDomainName, AppTitle } from "@emr/utils"

export const appConfig: AppConfig = {
	brand: {
		title: AppTitle,
		domain: getEnvDomainName("https://emr.timeprox.com"),
		themeColor: "#77b3d4",
		supportEmail: "support@emr.timeprox.com",
		redirectLandingToWaitList: true,
		allowRegistration: false,
	},
	locale: {
		prefix: "always" as const,
		default: "en-US",
		supported: ["en-US", "fr-CA"],
	},
	misc: {
		toastErrorTimeout: 5000,
	},
	redirects: {
		afterSignInUrl: "/dashboard",
		afterSignUpUrl: "/waitlist",
		afterSignOutUrl: "/",
	},
	tools: {
		assetGenerator: {
			iconFolderPath: "public/logo.png",
			options: {
				faviconStyle: "transparent",
				scaleSvg: 1.4,
				scaleIcon: 0.8,
			},
		},
	},
}
